import React from 'react';
import isNil from 'lodash/isNil';
import { useFieldValue } from '@atlassian/jira-issue-field-base/src/services/field-value-service/index.tsx';
import { STORY_POINTS } from '../../../../model/constants.tsx';
import type { Card } from '../../../../model/types.tsx';
import { useBacklogSelector } from '../../../../state/index.tsx';
import { getStoryPointFieldId } from '../../../../state/selectors/app/index.tsx';
import { backlogHasStoryPoints } from '../../../../state/selectors/cards/index.tsx';
import { getEstimationType } from '../../../../state/selectors/estimation/index.tsx';
import StoryPointFieldStatic from '../../card/card-contents/story-point-field/story-point-field-static/index.tsx';

export const StoryPointLite = ({ issue }: { issue: Card }) => {
	const estimationType = useBacklogSelector(getEstimationType);
	const shouldRenderStoryPointColumn = useBacklogSelector(backlogHasStoryPoints);
	const storyPointFieldId = useBacklogSelector(getStoryPointFieldId);

	const storyPointKey = storyPointFieldId || '';
	const [storyPointFieldValue] = useFieldValue({
		issueKey: issue.key,
		fieldKey: storyPointKey,
	});

	const hasEstimate = !isNil(issue.estimate);

	if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== STORY_POINTS)) {
		return null;
	}

	return (
		<StoryPointFieldStatic
			value={storyPointFieldValue ?? undefined}
			hasStoryPoints={hasEstimate}
			shouldRenderStoryPointColumn={shouldRenderStoryPointColumn}
		/>
	);
};
